import React from "react";
import { useWindowSize } from "react-use";

export const useCarousel = (items) => {
  const [active, setActive] = React.useState(0);
  const { width, height } = useWindowSize();

  React.useEffect(() => {
    const interval = setInterval(next, 10000);
    return () => {
      clearInterval(interval);
    };
  }, [active]);

  function next() {
    if (!items) return;
    if (active < items.length - 1) {
      setActive((prevState) => prevState + 1);
    } else {
      setActive(0);
    }
  }

  function prev() {
    if (!items) return;
    if (active !== 0) {
      setActive((prevState) => prevState - 1);
    } else {
      setActive(items.length - 1);
    }
  }

  const style = items && {
    transform: "translateX(0)",
    width: width > 1280 ? `${1000 * items.length}px` : `${100 * items.length}vw`,
    left: width > 1280 ? `-${active * ((1000 * items.length) / items.length)}px` : `-${active * ((100 * items.length) / items.length)}vw`,
  };

  return [active, style, next, prev];
};
